export const normalizeString = (value: string): string => {
  return (value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[^\w]/g, '');
};
